import template from './secondaryClaimEditor.html';
import controller from './secondaryClaimEditor.controller';

let component = {
  restrict: 'E',
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    staffUser: '<',
    position: '<',
    event: '<',
    claim: '<',
    canEdit: '<',
    onAdd: '&',
    onSave: '&',
    onRemove: '&',
    resubmitting: '<',

    /**
     * Reference to parent controller.
     * Note this is a hack; we should use require: { claimsModalController: '^claimsModal' } but cannot because it is
     * a $uibModal and not a directive/component so Angular can't find it by name
     */
    claimsModalController: '<',
  },
};

export default component;
